module.exports = __webpack_public_path__ + "img/register.3c012927.svg";